import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { SUBMIT_ORDER, SUBMIT_ORDER_2 } from "api/mutations/stock";
import ModalHeader from "utils/Modal/ModalHeader/ModalHeader";
import { ReactComponent as Coin } from "assets/images/icons/coin.svg";
import { ERROR, SECONDARY, stockTransType } from "../../../../constants";
import { getError, toCurrency, getBalance } from "utils/helpers";
import CustomSpinner from "utils/CustomSpinner/CustomSpinner";
import Toast from "utils/Alert/Toast/Toast";

const BuyStockConfirmation = ({ order = {}, toggle, nextStep, prevStep }) => {
	const [errorMsg, setErrorMsg] = useState();
	const { cashBalance, margin, margin_details } = getBalance();
	const { price_limit, account, price_type, quantity, type, term } = order;
	const { securityName, name, estTotal, stop_price } = order;
	const canBuy = cashBalance >= estTotal;
	const isMarginAccount = margin?.name === order?.account;

	const QUERY = term ? SUBMIT_ORDER : SUBMIT_ORDER_2;

	const [buyStock, { error, loading }] = useMutation(QUERY, {
		onCompleted: ({ submit_order }) => nextStep({}, submit_order?.message),
		onError: (err) => setErrorMsg(getError(err)),
	});

	const handleSubmit = () => {
		const variables = {
			account,
			name: securityName || name,
			price_type,
			quantity: parseInt(quantity),
			type,
		};
		price_type !== stockTransType.MARKET &&
			(variables.price_limit = parseFloat(price_limit));
		price_type === stockTransType.STOP_LIMIT &&
			(variables.stop_price = parseFloat(stop_price));
		term && (variables.term = term);
		buyStock({ variables });
	};

	return (
		<div>
			{error && <Toast msg={errorMsg} variant={ERROR} />}

			<div className="text-center pb-4 ">
				<ModalHeader
					type={SECONDARY}
					toggle={toggle}
					prevStep={prevStep}
					title="Confirm"
				/>

				<div className="px-sm-5 px-2">
					<div className="row flex__between green__light p-4 rounded">
						<div className="col-4">
							<Coin className="coin" />
						</div>

						<div className="col-8 text-start">
							<span className="heading4 text--primary">
								{isMarginAccount
									? "Trading Power"
									: "Available Balance"}
							</span>
							<p className="heading2 m-0">{`N${toCurrency(
								isMarginAccount
									? margin_details?.trading_power
									: cashBalance
							)}`}</p>
						</div>
					</div>

					{canBuy ? (
						<h4 className="fw-bold mt-5">
							A debit of{" "}
							<span className="text--primary">{`N${toCurrency(
								estTotal
							)}`}</span>{" "}
							is pending on your{" "}
							{isMarginAccount
								? "Trading Power"
								: "Available Cash"}{" "}
							Balance. Do you want to confirm this transaction?
						</h4>
					) : (
						<h4 className="fw-bold mt-5">
							You do not have sufficient funds to perform this
							transaction.
						</h4>
					)}

					{canBuy ? (
						<div className="flex__between pt-5">
							<button
								className="btn btn--lg btn--primary--bordered me-3"
								onClick={prevStep}
							>
								No
							</button>
							<button
								className="btn btn--lg btn--primary ms-3"
								onClick={handleSubmit}
								disabled={loading}
							>
								{loading ? <CustomSpinner /> : "Confirm"}
							</button>
						</div>
					) : (
						<div className="col-sm-6 col-12 mt-5 mx-auto">
							<button
								className="btn btn--lg btn--primary  "
								onClick={toggle}
							>
								Fund Available Cash
							</button>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default BuyStockConfirmation;
